/**
 * @fileoverview GET handler for the "/apps/user_info/merge_duplicate_users_running" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoMergeDuplicateUsersRunning } from "./constants";
import type { AppsUserInfoMergeDuplicateUsersRunningResult } from "./types";

export const getAppsUserInfoMergeDuplicateUsersRunning = reactQueryFetcherAdapter(
  appsUserInfoMergeDuplicateUsersRunning,
  (signal: AbortSignal): Promise<AppsUserInfoMergeDuplicateUsersRunningResult> => {
    return fetch("/apps/user_info/merge_duplicate_users_running", "GET", {}, { signal });
  }
);
